// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\HTTP\HeaderNames
// Generated on: <normalized>

export enum HeaderNames {
  API_GUID = 'Vx-Api-Guid',
  KERNAL_BYPASS = 'Vx-Api-Bypass',
  AUTH_JWT = 'Authorization',
  CRON_HEADER = 'Vx-Cron',
  WEB_RUNTIME_PROBE = 'Vx-Runtime-Probe',
  SLAVE_HEADER = 'Vx-Slave',
  LEDGER_KEY = 'Vx-Ledger-Key',
  UPDATE_KEY = 'Vx-Update-Key',
  TENANT_KEY = 'Vx-Tenant-Key',
  STRIPE_SIGNATURE = 'Stripe-Signature',
  ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin',
  ACCESS_CONTROL_ALLOW_HEADERS = 'Access-Control-Allow-Headers',
  ACCESS_CONTROL_EXPOSE_HEADERS = 'Access-Control-Expose-Headers',
  ACCESS_CONTROL_ALLOW_METHODS = 'Access-Control-Allow-Methods',
  ACCESS_CONTROL_ALLOW_CREDENTIALS = 'Access-Control-Allow-Credentials',
  ACCESS_CONTROL_MAX_AGE = 'Access-Control-Max-Age',
  VARY = 'Vary',
  CONTENT_TYPE = 'Content-Type',
  ACCEPT = 'Accept',
  ALLOW = 'Allow',
  CACHE_CONTROL = 'Cache-Control',
  IDEMPOTENCY_KEY = 'Idempotency-Key',
  MCP_CATALOGUE = 'Vx-Mcp-Catalogue',
  MCP_PROTOCOL_VERSION = 'MCP-Protocol-Version',
  MCP_SESSION_ID = 'Mcp-Session-Id',
  AGENT_CONVERSATION_ID = 'Vx-Agent-Conversation-Id',
  AGENT_SESSION_ID = 'Vx-Agent-Session-Id',
  AGENT_TURN_ID = 'Vx-Agent-Turn-Id',
  ORIGIN = 'Origin',
  REFERER = 'Referer',
  RATE_LIMIT_LIMIT = 'X-RateLimit-Limit',
  RATE_LIMIT_REMAINING = 'X-RateLimit-Remaining',
  RATE_LIMIT_RESET = 'X-RateLimit-Reset',
  RETRY_AFTER = 'Retry-After',
}

export const HeaderNamesCases = ["Vx-Api-Guid", "Vx-Api-Bypass", "Authorization", "Vx-Cron", "Vx-Runtime-Probe", "Vx-Slave", "Vx-Ledger-Key", "Vx-Update-Key", "Vx-Tenant-Key", "Stripe-Signature", "Access-Control-Allow-Origin", "Access-Control-Allow-Headers", "Access-Control-Expose-Headers", "Access-Control-Allow-Methods", "Access-Control-Allow-Credentials", "Access-Control-Max-Age", "Vary", "Content-Type", "Accept", "Allow", "Cache-Control", "Idempotency-Key", "Vx-Mcp-Catalogue", "MCP-Protocol-Version", "Mcp-Session-Id", "Vx-Agent-Conversation-Id", "Vx-Agent-Session-Id", "Vx-Agent-Turn-Id", "Origin", "Referer", "X-RateLimit-Limit", "X-RateLimit-Remaining", "X-RateLimit-Reset", "Retry-After"] as const;
